var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.links && _vm.links.length > 0
    ? _c(
        "div",
        { staticClass: "hots" },
        [
          _c("SidebarTitle", { attrs: { title: _vm.title } }),
          _vm._v(" "),
          _vm._l(_vm.links, function (range, index) {
            return _c("Range", {
              key: index,
              attrs: {
                text: range.name || range.title,
                width: range.width || range.weight,
                category: _vm.jurisdictionFromContent
                  ? _vm.type
                  : range.vid || range.vid || null,
                tid: _vm.jurisdictionFromContent ? _vm.tid : range.tid || null,
                jurisdiction: _vm.jurisdictionFromContent
                  ? range.tid
                  : _vm.tid || range.jurisdiction || null,
                topic: _vm.topic || null,
                type: _vm.jurisdictionFromContent ? _vm.type : range.vid,
              },
            })
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }